import React from "react";
import { Link } from "react-router-dom";
import { services } from "../mock";
import { Button } from "../components/ui/button";
import { Plane, FileCheck, MapPin, Hotel, Landmark, BookUser, Ticket, ShieldCheck, ArrowRight, Check } from "lucide-react";

const iconMap = { Plane, FileCheck, MapPin, Hotel, Landmark, BookUser, Ticket, ShieldCheck };

export default function Services() {
  const benefits = [
    "Personalised trip consultation",
    "Best price guarantee on flights & hotels",
    "Dedicated travel manager",
    "24/7 on-trip support",
    "Visa documentation & assistance",
    "Instant confirmations",
  ];

  return (
    <main className="pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.3em] text-[#5c8606] font-semibold">SERVICES</div>
        <h1 className="font-display text-5xl md:text-6xl font-bold text-slate-800 mt-3 max-w-3xl leading-tight">Everything you need under one sky.</h1>
        <p className="mt-5 text-lg text-slate-600 max-w-2xl">Seven specialised services designed to make your travel effortless — from paperwork to postcards.</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Plane;
            return (
              <div key={s.title} className="lift group bg-white p-8 rounded-2xl border border-slate-100 hover:border-[#ddedba]">
                <div className="w-14 h-14 rounded-2xl bg-[#f9fcf3] text-[#70a308] flex items-center justify-center mb-5 group-hover:bg-[#70a308] group-hover:text-white transition-colors">
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="text-xl font-bold text-slate-800">{s.title}</h3>
                <p className="text-sm text-slate-500 mt-2 leading-relaxed">{s.desc}</p>
                <button className="mt-5 text-sm font-semibold text-[#5c8606] flex items-center gap-1 group-hover:gap-2 transition-all">
                  Learn more <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            );
          })}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-24">
        <div className="bg-gradient-to-br from-[#f9fcf3] to-[#f7f9f2] border border-[#f0f7e1] rounded-3xl p-8 md:p-14 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-xs tracking-[0.3em] text-[#5c8606] font-semibold">WHY KITES FLY</div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-slate-800 mt-3">Travel, without the turbulence.</h2>
            <p className="mt-4 text-slate-600">We take care of the details so you can focus on the memories. Here's what you get with every booking.</p>
            <Link to="/contact">
              <Button className="mt-7 bg-gradient-to-r from-[#84c009] to-[#4f7700] hover:from-[#70a308] hover:to-[#416200] text-white rounded-full px-6 h-11 font-semibold">Get Started</Button>
            </Link>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            {benefits.map((b) => (
              <div key={b} className="bg-white rounded-xl p-4 flex items-start gap-3 border border-slate-100">
                <div className="w-6 h-6 rounded-full bg-[#70a308] flex items-center justify-center shrink-0 mt-0.5">
                  <Check className="w-3.5 h-3.5 text-white" />
                </div>
                <span className="text-sm text-slate-700">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
